// extracted by mini-css-extract-plugin
export default {"loginContainer":"login-container_loginContainer__KFypJ","logoStyling":"login-container_logoStyling__BqeP8"};